import NewLayout from "@components/new-ui/Layout";
import React, { FC } from "react";

const listItem1 = [
    "Unused portions of services on a pro-rata basis (unused service of platform in terms of future payments received advance only, as a subscription not in terms of actual product usage)",
    "Unused message credits can be refunded claimed within 6 months of non-usage",
    "Technical issues that prevent effective use of our services, as verified by our support team",
    "Unauthorized or fraudulent charges, subject to verification; and",
    "Other exceptional circumstances reviewed on a case-by-case basis.",
];

const listItem2 = ["One-time setup fees, if any", "Third-party integration costs", "Services that have been fully consumed or utilized"];

const listItem3 = [
    "Contact our support team at support@gallabox.com",
    "Provide transaction details and account information",
    "Include a clear explanation of the reason for your refund request",
    "Allow 7 Business Days for review and response",
];

const RefundPolicy: FC = () => {
    return (
        <NewLayout
            title="Refund Policy - Gallabox"
            description="Our cookie policy covers the use of cookies between your device and our site."
            canonical="https://gallabox.com/cookie-policy"
        >
            <section className="md:mt-36 max-w-6xl mx-auto px-10 mt-20">
                <h1 className="text-3xl text-center">REFUND POLICY</h1>
                <section className="md:my-20 my-10">
                    <p className="font-bold">General Refund Terms</p>
                    <p className="mt-5">
                        Refunds are considered on a pro-rata and need basis. Each refund request will be reviewed individually by our support team to determine eligibility based on
                        the specific circumstances of the case. Submission of a refund request does not guarantee approval.
                    </p>
                    <p className="mt-5 mb-5 font-bold">Refund Eligibility</p>
                    <section>
                        <p className="">Refunds may be granted in the following situations:</p>
                        <ul>
                            {listItem1.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </section>
                    <section>
                        <p className="font-bold mt-5 mb-5">Non-Refundable Services</p>
                        <p>The following services are generally non-refundable due to their nature and the costs incurred to provide them:</p>
                        <ul className="">
                            {listItem2.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>

                        <p>Refunds are not guaranteed and will be issued solely at Gallabox’s discretion.</p>
                    </section>
                    <section>
                        <p className="font-bold mt-5 mb-5">Requesting Refunds</p>
                        <p className="mt-5 mb-5">To request a refund:</p>

                        <ol>
                            {listItem3.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ol>
                    </section>
                    <section>
                        <p className="font-bold mt-5 mb-5">Unauthorized Charges</p>
                        <p>
                            If you believe you have been charged without authorization, contact our support team immediately at [support@gallabox.com]. Verified unauthorized
                            charges will result in a full refund.
                        </p>
                        <p className="mt-5 mb-5 font-bold">Disclaimer</p>
                        <p>
                            Gallabox reserves the right to deny refund requests that do not meet the above criteria or are deemed invalid or unreasonable after individual review by
                            our team.
                        </p>
                    </section>
                </section>
            </section>
        </NewLayout>
    );
};

export default RefundPolicy;
